function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20,
  r: 20,
  fill: "#ACB5C2"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.25 27.75L21.5 40c9.625-.625 17.5-7.5 19-18l-11-11-19.25 16.75z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.625 10.625h-17.5c-.688 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.563 1.25-1.25v-15c0-.688-.563-1.25-1.25-1.25z",
  fill: "#E4E7EC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#344E5F",
  d: "M9.875 13.125h20v1.25h-20z",
  opacity: 0.149
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.125,
  cy: 11.875,
  r: 0.625,
  fill: "#748499"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 11.25c-.375 0-.625.25-.625.625s.25.625.625.625.625-.25.625-.625-.25-.625-.625-.625zm10.625 4.375v7.5h5v-7.5h-5zM14.875 12.5c.375 0 .625-.25.625-.625s-.25-.625-.625-.625-.625.25-.625.625.25.625.625.625zm-3.75 3.125v11.25h11.25v-11.25h-11.25z",
  fill: "#748499"
});

function SvgCourseAdminTabPast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 41 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "course-admin-tab-past-3793d887a4043fdeec31f4f54abaabbb.svg";
export { SvgCourseAdminTabPast as ReactComponent };